import { useQuery } from '@tanstack/react-query'
import type { RiskAssessment } from '@mobi/api-types'
import { SignUpUrl, get, queryKeys } from '../../../Utils'

export const useRiskAssessment = () => {
  return useQuery<RiskAssessment>({
    queryKey: queryKeys.riskAssessment,
    queryFn: getRiskAssessment,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}

export function getRiskAssessment() {
  return get<RiskAssessment>(SignUpUrl.riskAssessment)
}
